import { isNil, omitBy } from 'lodash'

import { GetCatalogInitializerArgs } from 'types/api/arguments/get-catalog-initializer-args'
import { GetCatalogInitializersResp } from 'types/api/response/get-catalog-initializers-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getCatalogInitializers = (args: GetCatalogInitializerArgs) =>
  api.get<GetCatalogInitializersResp>('/catalog/initializers', {
    params: omitBy(args, isNil),
    headers: moneyObjectHeader,
  })
